export default __webpack_public_path__ + "static/media/logo.be5148b2.png";